export default "/img/readings-compass-ring-inner.7e5e97d8c118600df807571e46b62dd3.svg";